import ServiceBase from './serviceBase';
import { FlowCommentCreate, FlowCommentsFilter, FlowCommentList } from './types/Flow';

class OperEsrsCommentsService extends ServiceBase {
  create = async (data: FlowCommentCreate): Promise<void> =>
    this.post<void>('esrscomment/create', data);

  getList = async (filter: FlowCommentsFilter): Promise<FlowCommentList> =>
    this.post<FlowCommentList>('esrscomment/list', filter);

  exportExcel = async (operationId: number): Promise<boolean> => {
    await this.download(`esrscomment/excel/${operationId}`, undefined, true);
    return true;
  };
}

const operEsrsCommentsService = new OperEsrsCommentsService();

export default operEsrsCommentsService;
